export default (className: string): string => className.replace(/\s{2,}/g, ' ').trim();
